// extracted by mini-css-extract-plugin
export var dividerLine = "_54-0";
export var errorBackground = "_54-1";